import { landingDarkTheme } from './dark';

export * from './dark';
export * from './base';

export const LandingTheme = {
  darkTheme: landingDarkTheme,
};
